// 支付方式选择弹窗翻译

export const paymentMethod = {
    selectPaymentMethod: 'Select Payment Method',
    orderSummary: 'Order Summary',
    choosePaymentMethod: 'Choose your preferred payment method',
    creditCard: 'Credit/Debit Card',
    creditCardDescription: 'Pay securely with your credit or debit card via Stripe',
    paypalDescription: 'Pay with your PayPal account or PayPal balance',
    securityNote: 'Your payment information is encrypted and secure',
    processing: 'Processing payment...',
    paymentFailed: 'Payment failed. Please try again.',
    paymentCancelled: 'Payment was cancelled.',
    invalidPaymentMethod: 'Invalid payment method selected.',
    networkError: 'Network error. Please check your connection and try again.',
    paypalPayment: 'PayPal Payment',
    loadingPayPal: 'Loading PayPal...',
    paypalSecurityNote: 'Your payment is processed securely by PayPal'
  };
